<template>
    <div class="home" v-loading="loading">
        <div class="swiper-slide">
            <div class="page" v-if="language == 'ZH'">
                <div class="address-item">
                    <p class="name">深圳总部</p>
                    <p class="info" style="margin-top:30px;">地址：深圳市龙岗区坂田星河双子塔西塔41楼</p>
                    <p class="info">电话：0755-2623 0000</p>
                    <p class="info">传真：0755-8327 9527 </p>
                    <p class="info">手机：13902997058</p>
                </div>
                <div class="address-item">
                    <p class="name">北京公司</p>
                    <p class="info" style="margin-top:30px;">地址：北京市朝阳区望京SOHO塔二A座2306 </p>
                    <p class="info">电话：010-6556 0060</p>
                    <p class="info">传真：010-8550 0035</p>
                    <p class="info">手机：13901073300</p>
                </div>
                <div class="address-item">
                    <p class="name">广州公司</p>
                    <p class="info" style="margin-top:30px;">地址：广州市番禺区招商城市主场1栋506</p>
                    <p class="info">电话：020-8478 9853</p>
                    <p class="info">传真：020-8478 9853</p>
                    <p class="info">手机：13902232777</p>
                </div>
                <div class="address-item">
                    <p class="name">上海公司</p>
                    <p class="info" style="margin-top:30px;">地址：上海市闵行区新龙路1333弄78号楼303室</p>
                    <p class="info">电话：021-33660310</p>
                    <p class="info">传真：021-33667380</p>
                    <p class="info">手机：18901700000</p>
                </div>
            </div>
            <div class="page" v-else>
                <div class="address-item">
                    <p class="name">Shenzhen headquarters</p>
                    <p class="info" style="margin-top:30px;display: flex;white-space:normal;"><span>Address:Floor 41,
                            West Tower, Galaxy Twin Towers, Yabao
                            Road, Longgang District,Shenzhen, Guangdong, China</span></p>
                    <p class="info">Tel:0755-2623 0000</p>
                    <p class="info">Fax:0755-8327 9527</p>
                    <p class="info">Mobile:13902997058</p>
                </div>
                <div class="address-item">
                    <p class="name">Beijing branch</p>
                    <p class="info" style="margin-top:30px;display: flex;white-space:normal;"><span>Address:Room 2306,
                            Block A, Tower 2, Wangjing SOHO, Chaoyang District, Beijing, China.</span></p>
                    <p class="info">Tel:010-6556 0060</p>
                    <p class="info">Fax:010-8550 0035</p>
                    <p class="info">Mobile:13901073300</p>
                </div>
                <div class="address-item">
                    <p class="name">Guangzhou branch</p>
                    <p class="info" style="margin-top:30px;display: flex;white-space:normal;"><span>Address:Room 506,
                            Building 1,China Merchants City Hub,Panyu
                            District,Guangzhou,Guangdong,China</span></p>
                    <p class="info">Tel:020-8478 9853</p>
                    <p class="info">Fax:020-8478 9853</p>
                    <p class="info">Mobile:13902232777</p>
                </div>
                <div class="address-item">
                    <p class="name">Shanghai branch</p>
                    <p class="info" style="margin-top:30px;display: flex;white-space:normal;"><span>Address:Room 303,
                            Building 78,Lane 1338, Xinlong
                            Road,Minhang District,Shanghai, China</span></p>
                    <p class="info">Tel:021-33660310</p>
                    <p class="info">Fax:021-33667380</p>
                    <p class="info">Mobile:18901700000</p>
                </div>
            </div>
            <div class="product" v-if="language == 'ZH'" style="width: 100%;margin-left: 0;">
                <div class="product-item" style="width: 20%;">
                    <img src="../assets/img/app.jpg" style="width:10rem;height: 10rem;" alt="">
                    <p>下载App</p>
                </div>
                <div class="product-item" style="width: 20%;">
                    <img src="../assets/img/official.jpg" style="width:10rem;height: 10rem;" alt="">
                    <p><a href="https://m-vue.tmgolf.cn/" style="color:#333;text-decoration:none;">关注公众号</a></p>
                </div>
                <div class="product-item" style="width: 20%;">
                    <img src="../assets/img/miniapp.png" style="height:10rem;" alt="">
                    <p>小程序</p>
                </div>
                <div class="product-item" style="width: 20%;">
                    <img src="../assets/img/golf-shop.png" style="height:10rem;" alt="">
                    <p>导航至附近铁马专卖店</p>

                </div>
            </div>
            <div class="product" v-else>
                <div class="product-item">
                    <img src="../assets/img/client1.png" style="width:15rem;height: 15rem;" alt="">
                </div>
                <div class="product-item">
                    <img src="../assets/img/client2.png" style="width:15rem;height: 16rem;" alt="">
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "HelloWorld",
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            loading: true,
            caseList: [],
            newsList: [],
            swiperOption: {
                notNextTick: true,
                direction: "vertical",
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                slidesPerView: 1,
                mousewheel: true,
                mousewheelControl: true,
                height: window.innerHeight - 115,
                resistanceRatio: 0,
                observeParents: true,
                on: {},
            },
            language: localStorage.getItem("lang") || "ZH"
        };
    },
    created() { },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
    },
    mounted() {
        this.loading = false;
    },
};
</script>

<style scoped>
.swiper-slide {
    font-size: 24px;
    text-align: center;
    display: flex;
    flex-direction: column;

    align-content: center;

    max-width: 1350px;
    overflow: hidden;
    margin: 0 auto;
}

.page {
    display: flex;
    justify-content: space-around;
    align-content: center;
    margin-top: 150px;
    width: 100%;
}

.page .address-item {
    text-align: left;
    width: 20%;
}

.page .address-item .name {
    font-size: 1.25rem;
    color: #000;
    font-weight: bold;
}

.page .address-item .info {
    font-size: .8rem;
    color: #333;
    margin-top: 10px;
    white-space: nowrap;
}

.page .address-item .info p {
    margin-top: 10px;
}

.product {
    display: flex;
    justify-content: space-around;
    align-content: center;
    margin-top: 50px;
    font-size: 18px;
    width: 50%;
    margin-left: 25%;
}

.product .product-item {
    width: 60%;
}

.product p {
    margin-top: 0.5rem;
}
</style>